import { downloadStats } from '@/mocks/appData';

export default function StatsSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-primary-500">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {downloadStats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-background-50/20 mb-4">
                <i className={`${stat.icon} text-xl text-background-50`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-background-50 mb-1 font-heading">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/70">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}